import sanitizeHtml from 'sanitize-html';

export  const purify = (dirty) => {
    return sanitizeHtml(dirty, {
        allowedTags: sanitizeHtml.defaults.allowedTags.concat([
            'img', 'icon', 'button', 'html', 'head', 'body', 'meta', 'title', 'style', 'link',
            'center', 'font', 'span', 'colgroup'
        ]),
        allowVulnerableTags: true, // Required to preserve style tag content
        allowedAttributes: {
            a: [ 'href', 'name', 'target', 'title' ],
            i: [ 'data-feather' ],
            col: [ 'width', 'span' ],
            colgroup: [ 'width', 'span' ],
            img: [ 'src', 'srcset', 'alt', 'title', 'width', 'height', 'loading', 'border' ],
            table: [ 'cellpadding', 'cellspacing', 'width', 'height', 'align', 'bgcolor', 'border' ],
            tr: [ 'bgcolor', 'align', 'valign', 'height' ],
            td: [ 'width', 'height', 'align', 'valign', 'bgcolor', 'colspan', 'rowspan', 'nowrap' ],
            th: [ 'width', 'height', 'align', 'valign', 'bgcolor', 'colspan', 'rowspan', 'nowrap' ],
            html: [ 'lang', 'xmlns' ],
            meta: [ 'charset', 'name', 'content', 'http-equiv' ],
            link: [ 'rel', 'href', 'type' ],
            font: [ 'color', 'size', 'face' ],
            p: [ 'align', 'dir' ],
            div: [ 'align', 'dir' ],
            span: [ 'dir' ],
            '*': [ 'style', 'class', 'id', 'dir' ],
        },
    });
}